import { isAdminUser } from './adminUser';

const CHANNELS = {
  google_ads: { label: 'Google Ads', className: 'bg-amber-100 text-amber-800' },
  facebook: { label: 'Facebook', className: 'bg-blue-100 text-blue-800' },
  tiktok: { label: 'TikTok', className: 'bg-gray-900 text-white' },
  microsoft: { label: 'Bing', className: 'bg-cyan-100 text-cyan-800' },
};

/** Ad badge for administrators only. Returns null for every other role. */
export function getAdAttribution(ride = {}) {
  if (!isAdminUser()) return null;
  const channel = ride?.ad_channel;
  if (!channel) return null;
  const known = CHANNELS[channel];
  const sourceName = ride.ad_source ? String(ride.ad_source) : '';
  const label = known?.label || sourceName || 'Reklamë';
  const campaign = ride.ad_campaign_id || ride.ad_campaign_name || '';
  return {
    label,
    campaign,
    className: known?.className || 'bg-emerald-100 text-emerald-800',
    text: campaign ? `${label} · ${campaign}` : label,
  };
}
